// Actions
export const UNLOCK_SCENE = 'unlock_scene'
export const SELECT_CHOICE = 'select_choice'
export const SET_INVENTORY_ITEMS = 'set_inventory_items'
export const CHANGE_SETTINGS = 'change_settings'
export const OPEN_QUEST = 'open_quest'
export const CLOSE_QUEST = 'close_quest'
export const SELECT_CHAPTER = 'select_chapter'

// Events
export const EVENT_GENERAL_CUSTOM = 'general_custom_event'
